import * as XLSX from 'xlsx';

export type ExcelColumn<T> = {
  header: string;
  value: (row: T) => string | number | boolean | null | undefined;
};

/** Build and download an .xlsx file from tabular data. */
export function exportRowsToExcel<T>(
  rows: T[],
  columns: ExcelColumn<T>[],
  fileName: string,
  sheetName = 'Sheet1',
): void {
  const workbook = XLSX.utils.book_new();
  appendSheet(workbook, rows, columns, sheetName);
  const safeName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
  XLSX.writeFile(workbook, safeName);
}

export function exportSheetsToExcel(
  sheets: Array<{
    name: string;
    rows: Record<string, string | number | boolean | null | undefined>[];
  }>,
  fileName: string,
): void {
  const workbook = XLSX.utils.book_new();
  sheets.forEach((sheet) => {
    const data = sheet.rows.map((row) => {
      const record: Record<string, string | number> = {};
      Object.entries(row).forEach(([key, value]) => {
        if (value === null || value === undefined) record[key] = '';
        else if (typeof value === 'boolean') record[key] = value ? 'Yes' : 'No';
        else record[key] = value;
      });
      return record;
    });
    const worksheet = XLSX.utils.json_to_sheet(data.length ? data : [{}]);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name.slice(0, 31));
  });
  const safeName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
  XLSX.writeFile(workbook, safeName);
}

function appendSheet<T>(
  workbook: XLSX.WorkBook,
  rows: T[],
  columns: ExcelColumn<T>[],
  sheetName: string,
): void {
  const data = rows.map((row) => {
    const record: Record<string, string | number> = {};
    columns.forEach((col) => {
      const value = col.value(row);
      if (value === null || value === undefined) {
        record[col.header] = '';
      } else if (typeof value === 'boolean') {
        record[col.header] = value ? 'Yes' : 'No';
      } else {
        record[col.header] = value;
      }
    });
    return record;
  });
  const worksheet = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
}
